// import { oracleTransport } from "@logger/src/transports/pino/oracleTransport.transport";
// import { oracleTransport } from "../../../logger/dist/oracleTransport.transport.mjs";
// const logger = pino(oracleTransport());
export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      // logger: logger,
    },
  };
});